import { useEffect, useCallback } from 'react'
import { useHistory, useRouteMatch } from 'react-router'
import { routes } from '../../routing/routes'
import { useDomainMessages } from '../domain/intl'

const DOUBLE_KEY_WINDOW_MS = 500

export const useFastFind = () => {
  const history = useHistory()
  const messages = useDomainMessages({
    prompt: 'customersAndOrdersDomain.fastFind.prompt',
  })
  const fastFindEnabled = useRouteMatch([
    routes['app-admin-customers-and-orders-ipp-customer-details'],
    routes['app-admin-customers-and-orders-ipp-customer-order-details'],
  ])

  const handleFastFind = useCallback(() => {
    const query = window.prompt(messages.prompt)
    if (query != null && query.trim() !== '') {
      const basePath = routes['app-admin-customers-and-orders-dashboard-wildcard'].replace('/*', '')
      history.push(`${basePath}/admin/search/fast_find?query=${encodeURIComponent(query.trim())}`)
    }
  }, [history, messages.prompt])

  useEffect(() => {
    if (!fastFindEnabled) return

    let lastFKeyTime = 0

    const handleKeyDown = (e: KeyboardEvent) => {
      const target = e.target as HTMLElement
      if (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA' || target.isContentEditable) {
        return
      }

      if (e.key === 'f' || e.key === 'F') {
        const now = Date.now()
        if (now - lastFKeyTime <= DOUBLE_KEY_WINDOW_MS) {
          e.preventDefault()
          handleFastFind()
          lastFKeyTime = 0
        } else {
          lastFKeyTime = now
        }
      } else {
        lastFKeyTime = 0
      }
    }

    document.addEventListener('keydown', handleKeyDown)
    return () => document.removeEventListener('keydown', handleKeyDown)
  }, [handleFastFind, fastFindEnabled])
}
